import { actions, helpers } from 'app-webtech-core';
import { enterFullscreen } from 'app-modules/player/actions';
import { PREVIOUS_CHANNEL } from './types';

const remoteControllerPreviousChannelButtonAction = helpers.actions.actionCreator(PREVIOUS_CHANNEL);

export const remoteControllerPreviousChannelButtonThunkAction = () => async (dispatch) => {
  await dispatch(remoteControllerPreviousChannelButtonAction());
  await dispatch(actions.guide.playPreviousPlayedChannel());
  await dispatch(enterFullscreen());
};
